import styled from "@emotion/styled";

export const BannerContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-gap: 1em;
  padding: 1em;
  align-items: center;
  grid-template-columns: repeat(auto-fit, minmax(17rem, 1fr));
  position: relative;
  ::after {
    content: " ";
    background-image: ${(props) => `url(${props.background})`};
    background-repeat: no-repeat;
    background-position: bottom left;
    background-size: cover;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: -45%;
    z-index: -1;
    @media (max-width: 592px) {
      background-position: center left;
      right: -35%;
      top: 21%;
      height: 80%;
      transform: rotate(25deg);
    }
    @media (max-width: 321px) {
      background-position: center left;
      right: -35%;
      top: 32%;
      height: 70%;
      transform: rotate(25deg);
    }
  }
`;

export const BannerTextContainer = styled.div`
  text-align: center;

  & h1 {
    background: linear-gradient(
      to left bottom,
      #f9993c,
      #fb9f33,
      #fca628,
      #fcad1a,
      #fbb400
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: clamp(2rem, 3vw, 3rem);
    font-weight: 700;
    margin: 0;
  }
  & h2 {
    font-size: clamp(1rem, 2.5vw, 2rem);
    font-weight: 400;
    margin: 0;
  }
  & h3 {
    font-size: clamp(1rem, 2.5vw, 1.3rem);
    font-weight: 300;
    @media (max-width: 768px) {
      & br {
        display: none;
      }
    }
    .br-display {
      font-weight: 500;
      & br {
        display: none;
      }
      @media (max-width: 768px) {
        & br {
          display: block;
        }
      }
    }
  }
  .h3-br-display-mobile {
    display: none;
    @media (width: 1024px) {
      display: block;
    }
    @media (max-width: 375px) {
      display: block;
    }
  }
  .h3-br-display-ipad {
    display: none;
    @media (width: 1024px) {
      display: block;
    }
  }
  .h3-br-display {
    display: block;
  }

  .subTitle {
    font-size: clamp(2rem, 3vw, 2.7rem);
    font-weight: 600;
    text-decoration-line: underline;
    text-decoration-color: #fbce66;
    text-underline-offset: 0.2em;
    text-decoration-thickness: 0.15em;
  }
  .subTitle-bold {
    font-size: clamp(1.8rem, 3vw, 2.7rem);
    font-weight: 600;
  }
  .subTitle-not-bold {
    font-size: clamp(1.8rem, 3vw, 2.7rem);
    font-weight: 300;
  }
  .subTitle-bold-only {
    font-size: clamp(1.27rem, 3vw, 1.8rem);
    font-weight: 600;
  }
  .h2-subTitle {
    font-size: clamp(1rem, 2.5vw, 1.7rem);
  }

  & strong {
    font-weight: 500;
  }
  .bold-color {
    color: #fbb400;
  }
  .br-disable-display-ipad {
    @media (max-width: 1024px) {
      & br {
        display: none;
      }
    }
  }
  .br-display-iphone {
    @media (max-width: 376px) {
      & br {
        display: block;
      }
    }
  }
`;

export const GridContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-gap: 1em;
  padding: 1em;
  align-items: center;
  grid-template-columns: repeat(auto-fit, minmax(17rem, 1fr));
  position: relative;
  ::before {
    ${(props) => props.styledBackground};
    @media (max-width: 591px) {
      content: unset;
    }
  }
  div:nth-of-type(1) {
    order: ${(props) => (props.reverse ? 1 : 0)};
    @media (max-width: 591px) {
      order: ${(props) => (props.reverse ? 0 : 0)};
    }
  }
  & img {
    /* height: auto; */
    max-width: 100%;
    border: none;
  }
`;

export const TextContainer = styled.div`
  ${(props) => props.styledText};
  padding: 0.5em 1em;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 592px) {
    height: 100%;
  }
  .number {
    font-size: clamp(2.5rem, 3vw, 3rem);
    font-weight: 600;
    text-align: start;
  }
  & h1 {
    font-size: clamp(1.1rem, 2.5vw, 1.7rem);
    font-weight: 600;
    text-align: start;
    margin: 0;
  }
  .medium-bold {
    font-size: clamp(1.1rem, 2.5vw, 1.7rem);
    font-weight: 300;
    text-align: start;
    margin: 0;

    @media (max-width: 321px) {
      & br {
        display: none;
      }
    }
    & strong {
      font-weight: 500;
    }
  }

  & ul {
    font-weight: 300;
    text-align: start;
    font-size: clamp(1rem, 2.5vw, 1.1rem);
    padding-inline-start: 1.5em;
  }
  & ul li {
    @media (max-width: 769px) {
      & br {
        display: none;
      }
    }
  }
  & h2 {
    font-size: clamp(1rem, 2.5vw, 1.1rem);
    font-weight: 300;
    text-align: start;

    @media (max-width: 769px) {
      & br {
        display: none;
      }
    }
  }
  .wrap-icon {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin: 1.5em 0em;
    gap: 1em;
  }
  & strong {
    font-weight: 500;
  }
  .bold-color {
    font-weight: 600;
    color: #fbb400;
  }
  .br-word {
    & br {
      display: none;
    }
    @media (max-width: 321px) {
      & br {
        display: block;
      }
    }
  }
  .br-display-iphone {
    @media (max-width: 415px) {
      & br {
        display: block;
      }
    }
  }
  .br-disable-display-ipad {
    display: none;
    @media (min-width: 1025px) {
      display: block;
    }
  }
`;

export const WrapperComponent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .logo {
    @media (max-width: 592px) {
      padding-bottom: 6em;
    }
  }
`;
export const WrapperText = styled.div`
  text-align: center;
  position: relative;
  ::before {
    content: " ";
    background-image: ${(props) => `url(${props.backgroundLeft})`};
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    position: absolute;
    top: -40%;
    left: 10%;
    width: 25%;
    height: 80%;
    z-index: -1;
    @media (max-width: 592px) {
      left: 0%;
      top: -60%;
    }
  }
  ::after {
    content: " ";
    background-image: ${(props) => `url(${props.backgroundRight})`};
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    position: absolute;
    bottom: 0%;
    right: 10%;
    width: 20%;
    height: 60%;
    z-index: -1;
    @media (max-width: 592px) {
      right: 0%;
      bottom: -60%;
    }
  }

  & h1 {
    font-weight: 300;
    font-size: clamp(1.2rem, 2.5vw, 1.7rem);
    & strong {
      font-weight: 500;
    }
    .highlight {
      color: #fbb400;
    }
  }
  & h2 {
    font-weight: 300;
    font-size: clamp(1rem, 2.5vw, 1.5rem);
    margin: 0;
  }
  & a {
    all: unset;
    font-size: clamp(2rem, 2.5vw, 2.5rem);
    font-weight: 500;
    color: #3b75a4;
    cursor: pointer;
    :hover {
      text-decoration: underline;
    }
  }
`;

export const WrapperGallery = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 0.5em;
  & img {
    max-width: 100%;
    border: none;
  }

  .grid-gif {
    grid-column: span 3;
  }
  .grid-image {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  @media (max-width: 592px) {
    grid-template-columns: auto;
    .grid-image {
      grid-column: span 3;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 0.5em;
    }
  }
`;
